import { Grid, Text, Link, Spacer } from '@geist-ui/react'

import { ReactComponent as FacebookIcon } from '../../assets/footer/facebook-icon.svg'
import { ReactComponent as LinkedInIcon } from '../../assets/footer/linkedin-icon.svg'
import { ReactComponent as InstagramIcon } from '../../assets/footer/instagram-icon.svg'

export const Footer = () => {
  const facebookUrl = 'https://www.facebook.com/noraconlaenne/'
  const linkedinUrl = 'https://www.linkedin.com/in/nora-gallia-671ba5150'
  const instagramUrl = 'https://www.instagram.com/noraconlaenne/'

  return (
    <Grid.Container gap={0} justify="center">
      <Grid xs={24} style={{ marginBottom: '5px' }}>
        <Grid.Container gap={1.5} justify="center">
          <Grid>
            <Link href={facebookUrl} target='_blank' rel='noopener noreferrer'>
              <FacebookIcon className='pointer' />
            </Link>
          </Grid>
          <Grid>
            <Link href={linkedinUrl} target='_blank' rel='noopener noreferrer'>
              <LinkedInIcon className='pointer' />
            </Link>
          </Grid>
          <Grid>
            <Link href={instagramUrl} target='_blank' rel='noopener noreferrer'>
              <InstagramIcon className='pointer' />
            </Link>
          </Grid>
        </Grid.Container>
      </Grid>

      <Grid xs={24} justify="center" style={{ marginBottom: '5px' }}>
        <Text className='lato' small>nora.gallia@gmail.com</Text>
      </Grid>

      <Spacer h={2} />

      <Grid xs={24} justify="center">
        <Text className='lato text-center' small>
          © Nora Gallia {new Date().getFullYear()} - 02626150995 - Design by Nora Gallia
        </Text>
      </Grid>

      <Spacer h={2} />
    </Grid.Container>
  )
}
